import React, { Component } from 'react';
import moment from 'moment-timezone';
import CustomCheckbox from '../../../util_components/custom_checkbox';
import Button from '../../../util_components/button';
import CustomDatePicker from '../../../util_components/custom_date_picker';
import { get_api } from '../../../../redux/api_funcs';
import { get_api_url } from '../../../../utils/urls';
import {
  build_active_packages_url,
  build_charge_preview_url,
  build_create_membership_payload,
  filter_create_membership_packages,
  format_preview_amount,
  get_selected_package,
  week_options
} from './create_membership_utils';

export default class CreateSubs extends Component {
  state = {
    active_packages: [],
    package_uuid: '',
    subscription_start_date: moment().format('YYYY-MM-DD'),
    number_of_week: 28,
    change_to_four_weeks_on_renewal: false,
    show_summary: false,
    loading_packages: true,
    error_message: '',
    preview: null,
    preview_loading: false,
    preview_error: ''
  };

  preview_seq = 0;

  componentDidMount() {
    this.load_active_packages();
  }

  load_active_packages = () => {
    this.setState({ loading_packages: true, error_message: '' });
    const url = build_active_packages_url(get_api_url('active_packages'), this.props.student_uuid);
    get_api(url, true)
      .then((res) => {
        const active_packages = filter_create_membership_packages(res.data.packages || []);
        this.setState({
          active_packages,
          package_uuid: active_packages[0]?.uuid || '',
          loading_packages: false
        });
      })
      .catch((e) => {
        let error_message;
        try {
          error_message = e.response.data.message;
        } catch (err) {
          error_message = 'Failed to load active packages';
        }
        this.setState({ loading_packages: false, error_message });
      });
  };

  // Built from the payload Confirm submits, so the quoted amount is the charged amount.
  load_charge_preview = () => {
    const { package_uuid } = this.state;
    if (!package_uuid || !this.props.student_uuid) return;
    const seq = (this.preview_seq += 1);
    this.setState({ preview: null, preview_loading: true, preview_error: '' });
    const url = build_charge_preview_url(
      get_api_url('membership_charge_preview'),
      this.build_payload()
    );
    get_api(url, true)
      .then((res) => {
        if (seq !== this.preview_seq) return;
        this.setState({ preview: res.data.preview, preview_loading: false });
      })
      .catch((e) => {
        if (seq !== this.preview_seq) return;
        let preview_error;
        try {
          preview_error = e.response.data.message;
        } catch (err) {
          preview_error = 'Could not load the charge amount';
        }
        this.setState({ preview: null, preview_loading: false, preview_error });
      });
  };

  get_selected_package = () => {
    const { active_packages, package_uuid } = this.state;
    return get_selected_package(active_packages, package_uuid);
  };

  build_payload = () => {
    const {
      package_uuid,
      subscription_start_date,
      number_of_week,
      change_to_four_weeks_on_renewal
    } = this.state;
    return build_create_membership_payload({
      package_uuid,
      student_uuid: this.props.student_uuid,
      subscription_start_date,
      number_of_week,
      change_to_four_weeks_on_renewal,
      country: this.props.country
    });
  };

  on_change = (e) => this.setState({ [e.target.name]: e.target.value });

  // Quotes on entry to the confirm screen, and on every re-entry so edits made after Back reprice.
  toggle_summary = () => {
    const show_summary = !this.state.show_summary;
    this.setState({ show_summary }, () => {
      if (show_summary) this.load_charge_preview();
    });
  };

  confirm_purchase = () => this.props.submit_subscription(this.build_payload());

  render_charge_amount = () => {
    const { preview, preview_loading, preview_error } = this.state;
    if (preview_loading) {
      return <span className="create-membership-charge-status">Loading...</span>;
    }
    if (preview_error) {
      return <span className="create-membership-charge-status is-error">{preview_error}</span>;
    }
    return (
      <span className="create-membership-charge-amount">{format_preview_amount(preview)}</span>
    );
  };

  render_summary = () => {
    const { subscription_start_date, number_of_week, change_to_four_weeks_on_renewal, preview } =
      this.state;
    const selected_package = this.get_selected_package();
    return (
      <div className="create-membership-popup">
        <div className="create-membership-header">
          <h3>Confirm Membership Purchase</h3>
        </div>
        <div className="create-membership-summary">
          <div className="subs-summ">
            <span>Package</span>
            {preview?.package_name || selected_package.name}
          </div>
          <div className="subs-summ">
            <span>Subscription start date</span>
            {preview?.subscription_start_date || subscription_start_date}
          </div>
          <div className="subs-summ">
            <span>Number of weeks</span>
            {preview?.number_of_week || number_of_week}
          </div>
          <div className="subs-summ create-membership-charge-row">
            <span>User will be charged</span>
            {this.render_charge_amount()}
          </div>
          <div className="subs-summ">
            <span>Change to 4 weeks on renewal</span>
            {change_to_four_weeks_on_renewal ? 'Yes' : 'No'}
          </div>
        </div>
        <div className="create-membership-actions">
          <button
            disabled={this.props.loading || this.state.preview_loading}
            onClick={this.confirm_purchase}
          >
            {this.props.loading ? 'Creating...' : 'Confirm'}
          </button>
          <button disabled={this.props.loading} onClick={this.toggle_summary}>
            Back
          </button>
        </div>
      </div>
    );
  };

  render_package_form = () => {
    const {
      active_packages,
      package_uuid,
      subscription_start_date,
      number_of_week,
      change_to_four_weeks_on_renewal,
      loading_packages,
      error_message
    } = this.state;
    const selected_package = this.get_selected_package();

    if (loading_packages) {
      return <div className="create-membership-loading">Loading packages...</div>;
    }

    if (error_message) {
      return (
        <div className="create-membership-error">
          <div>{error_message}</div>
          <Button onClick={this.load_active_packages}>Retry</Button>
        </div>
      );
    }

    return (
      <div className="create-membership-form">
        <div className="create-membership-field">
          <label>Package name</label>
          <select name="package_uuid" value={package_uuid} onChange={this.on_change}>
            {active_packages.map((active_package) => (
              <option key={active_package.uuid} value={active_package.uuid}>
                {active_package.name}
              </option>
            ))}
          </select>
          {!!selected_package.description && (
            <div className="cre-member-sub-heading">{selected_package.description}</div>
          )}
        </div>

        <div className="create-membership-field">
          <label>Subscription start date</label>
          <CustomDatePicker
            value={subscription_start_date}
            handleChange={(date) => this.setState({ subscription_start_date: date })}
            minDate={moment().format('YYYY-MM-DD')}
          />
        </div>

        <div className="create-membership-field">
          <label>Number of weeks</label>
          <select name="number_of_week" value={number_of_week} onChange={this.on_change}>
            {week_options.map((week) => (
              <option key={week} value={week}>
                {week}
              </option>
            ))}
          </select>
        </div>

        <div className="create-membership-checkbox">
          <CustomCheckbox
            label="Change to 4 weeks on renewal"
            checked={change_to_four_weeks_on_renewal}
            onClick={() =>
              this.setState({
                change_to_four_weeks_on_renewal: !change_to_four_weeks_on_renewal
              })
            }
          />
        </div>

        <div className="create-membership-actions">
          <Button disabled={!package_uuid || this.props.loading} onClick={this.toggle_summary}>
            Continue
          </Button>
        </div>
      </div>
    );
  };

  render() {
    if (this.state.show_summary) {
      return this.render_summary();
    }

    return (
      <div className="create-membership-popup">
        <div className="create-membership-header">
          <h3>Create Membership</h3>
        </div>
        {this.render_package_form()}
      </div>
    );
  }
}
